module.exports = __webpack_public_path__ + "static/media/placeholder.506c1f7b.png";